import { MultiSelect } from 'primereact/multiselect';

const PFMultiSelect = props => <MultiSelect {...props} />;

export default PFMultiSelect;
